import { ISectionLoggerFactory, LoggingSection } from "@multiweb/logging";
import { InputFake } from "@multiweb/reactComponents";
import { OWDataType } from "@multiweb/types/contracts";
import { DIContainer } from "../../Global/Base/DIContainer";
import { StoreOriginalPrototypeMixin } from "../../Global/Base/Mixins/StoreOriginalPrototypeMixin";
import { NumberUtils } from "../../Global/Base/Utils/NumberUtils";
import { MultiEditMixin } from "../UI.Controls/mixins/multiEditMixin";
import { ContainerEditableControl } from "../UI/UI/Controls/ContainerEditableControl";
import { FormControlParams } from "../UI/UI/Controls/ControlInterfaces";
import { NumEditBase } from "./NumEditBase";

/** Třída pro tvorbu NumEditu. */
const NumEditClass = StoreOriginalPrototypeMixin(MultiEditMixin(ContainerEditableControl, InputFake), ContainerEditableControl);

/** Typ instance {@link NumEditClass} */
type NumEditClassInstance = InstanceType<typeof NumEditClass>;

/**
 * Továrna pro získávání nových instancí {@link NumEditClass}
 */
export interface INumEditFactory {
    /**
     * Vrátí novou instanci {@link NumEditClass}.
     */
    create(params: FormControlParams): NumEditClassInstance;
}

class NumEditFactory implements INumEditFactory {
    public create(params: FormControlParams): NumEditClassInstance {
        const elementCreator = NumEditBase;
        const copyAttrs = new Map<string, string>([["data-minvalue", "min"], ["data-maxvalue", "max"], ["data-displayformat", "displayformat"]]);
        const onSetDataType = (el: HTMLInputElement, dataType: OWDataType | string) => {
            const numEdit = el as NumEditBase;

            // komponentě se nastaví, zda má pracovat pouze s celými čísly
            numEdit.wholeNumbers = NumberUtils.isWholeNumberType(dataType);

            if (!numEdit.hasAttribute("displayFormat")) // nebyl nastaven specifický displayFormat
                numEdit.displayFormat = NumberUtils.getDefaultFormat(dataType); // tak se nastaví podle datového typu

            const bounds = NumberUtils.getTypeMinMax(dataType);
            if (bounds == null)
                return;

            // a nastaví se jí minimální a maximální hodnota podle typu (pokud není z definice omezena už více)
            if (el.min == null || el.min === "" || +el.min < bounds.min)
                el.min = bounds.min.toString();
            if (el.max == null || el.max === "" || +el.max > bounds.max)
                el.max = bounds.max.toString();
            params.element.focus = () => {
                el.focus();
            };
        };

        const logger = DIContainer.instance.create(ISectionLoggerFactory).create(LoggingSection.numEdit);

        return new NumEditClass({
            elementCreator,
            copyAttrs,
            onSetDataType,
            logger,
            parentElement: params.element,
            originalRightsDefinition: params.originalRightsDefinition,
        });
    }
}

export const numEditFactory = new NumEditFactory();
